import { render, staticRenderFns } from "./MyTextBox.vue?vue&type=template&id=0a858172&"
import script from "./MyTextBox.vue?vue&type=script&lang=js&"
export * from "./MyTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports